































import Vue from 'vue'
import VueI18n from "vue-i18n";
import { Component, Prop } from "vue-property-decorator";

import { PollPost, QuizPost } from "../../types";

@Component({})
export default class PollQuizTypePreview extends Vue {
  @Prop() message!: PollPost | QuizPost

  @Prop() i18n!: VueI18n
}
